import React from 'react';
import BaseInput from '../Base/BaseInput';
import BaseSelect from '../Base/BaseSelect';
import { Authorizer } from '../../models/AuthorizerModel';
import {
  finalizeFormTextField,
  sanitizeFormTextField,
} from '../../utils/textInputSanitize';

type Props = {
  value: Authorizer;
  onChange: (a: Authorizer) => void;
  error?: string | null;
  companies: { value: string; label: string }[];
  fieldErrors?: Record<string, string>;
};

const AuthorizerForm: React.FC<Props> = ({ value, onChange, companies, fieldErrors = {} }) => {
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value: v } = e.target;
    onChange({
      ...value,
      [name]: name === 'company' ? Number(v) : v,
    });
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    onChange({ ...value, [name]: sanitizeFormTextField(name, v) });
  };

  const handleTextBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    const next = finalizeFormTextField(name, v);
    if (next !== (value as any)[name]) {
      onChange({ ...value, [name]: next });
    }
  };

  return (
    <div className="authorizer-form">
      <div className="form-row">
        <div className="form-field full-width">
          <BaseSelect
            label="Empresa"
            name="company"
            value={String(value.company ?? '')}
            onChange={handleSelectChange}
            options={companies.map((c) => ({ value: String(c.value), label: c.label }))}
            placeholder="Seleccionar empresa"
          />
          {fieldErrors.company && (
            <div className="form-error" role="alert">
              {fieldErrors.company}
            </div>
          )}
        </div>
      </div>

      <div className="form-row">
        <div className="form-field">
          <BaseInput
            label="Nombre"
            name="name"
            value={value.name ?? ''}
            onChange={handleTextChange}
            onBlur={handleTextBlur}
            required
            error={fieldErrors.name}
          />
        </div>

        <div className="form-field">
          <BaseInput
            label="Apellido"
            name="first_lastname"
            value={value.first_lastname ?? ''}
            onChange={handleTextChange}
            onBlur={handleTextBlur}
            required
            error={fieldErrors.first_lastname}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-field">
          <BaseInput
            label="Número"
            name="phone_number"
            value={value.phone_number ?? ''}
            onChange={handleTextChange}
            onBlur={handleTextBlur}
            error={fieldErrors.phone_number}
          />
        </div>

        <div className="form-field">
          <BaseInput
            label="Correo electrónico"
            name="email"
            type="email"
            value={value.email ?? ''}
            onChange={handleTextChange}
            onBlur={handleTextBlur}
            error={fieldErrors.email}
          />
        </div>
      </div>
    </div>
  );
};

export default AuthorizerForm;
